import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { TPartnerPlanExportFormats } from 'legacy/lut/classes/services/partner360/ExportCommitmentService'
import { IPartnerDataFiles } from 'legacy/lut/features/partner360/configuration/models/partnerDataFiles'
import sanitizeHtml from 'sanitize-html'

import { Nullable } from 'clickNgo/models/utils'
import settings from 'src/config/settings'

import { TPartnerDataFileField } from '../models/partnerDataFileField'

interface IDownloadPartnerPlanButtonParameters {
  uid: Nullable<string>
  files: IPartnerDataFiles
  programType: ProgramTypes
  isDistributor: boolean
  isRetail: boolean
  exportFormat: TPartnerPlanExportFormats
}

export const downloadPartnerPlan = async ({
  uid,
  files,
  programType,
  exportFormat,
  isDistributor,
  isRetail,
}: IDownloadPartnerPlanButtonParameters) => {
  if (uid) {
    const formId = 621

    let fieldSuffix = programType ? programType.replaceAll(' ', '') : ''

    if (isDistributor) {
      fieldSuffix = 'Distributor'
    } else if (isRetail) {
      fieldSuffix = 'Retail'
    }

    const fieldName = `exportedFile${fieldSuffix}` as TPartnerDataFileField
    const fileName = files[fieldName] || `PartnerPlan.${exportFormat}`

    const attachmentUrl = `${settings.dataServerUrl}/form/${formId}/attachments/v2/${uid}/${fieldName}`

    const link = document.createElement('a')
    link.href = sanitizeHtml(attachmentUrl)
    link.target = '_blank'
    link.setAttribute('download', fileName)
    link.click()
  }

  return {}
}
